// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ToolDetail_container__WYLsJ {
  max-width: 500px;
  margin: 40px auto;
  padding: 24px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.08);
}
.ToolDetail_button__HJXBC {
  background: #1976d2;
  color: #fff;
  border: none;
  padding: 8px 16px;
  border-radius: 4px;
  font-size: 1rem;
  cursor: pointer;
  transition: background 0.2s;
}
.ToolDetail_button__HJXBC:hover {
  background: #1565c0;
}
.ToolDetail_imagePreviewArea__Sc2vw {
  display: flex;
  gap: 8px;
  margin: 12px 0 16px 0;
}
.ToolDetail_imagePreview__v1yrs {
  width: 160px;
  height: 160px;
  object-fit: cover;
  border-radius: 4px;
  border: 1px solid #eee;
}
.ToolDetail_info__Lk2lv {
  font-size: 1.05em;
  margin-bottom: 6px;
  color: #444;
}
`, "",{"version":3,"sources":["webpack://./src/Page/Tools/ToolDetail.module.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,sCAAsC;AACxC;AACA;EACE,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,2BAA2B;AAC7B;AACA;EACE,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,QAAQ;EACR,qBAAqB;AACvB;AACA;EACE,YAAY;EACZ,aAAa;EACb,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;AACxB;AACA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;AACb","sourcesContent":[".container {\r\n  max-width: 500px;\r\n  margin: 40px auto;\r\n  padding: 24px;\r\n  background: #fff;\r\n  border-radius: 8px;\r\n  box-shadow: 0 2px 8px rgba(0,0,0,0.08);\r\n}\r\n.button {\r\n  background: #1976d2;\r\n  color: #fff;\r\n  border: none;\r\n  padding: 8px 16px;\r\n  border-radius: 4px;\r\n  font-size: 1rem;\r\n  cursor: pointer;\r\n  transition: background 0.2s;\r\n}\r\n.button:hover {\r\n  background: #1565c0;\r\n}\r\n.imagePreviewArea {\r\n  display: flex;\r\n  gap: 8px;\r\n  margin: 12px 0 16px 0;\r\n}\r\n.imagePreview {\r\n  width: 160px;\r\n  height: 160px;\r\n  object-fit: cover;\r\n  border-radius: 4px;\r\n  border: 1px solid #eee;\r\n}\r\n.info {\r\n  font-size: 1.05em;\r\n  margin-bottom: 6px;\r\n  color: #444;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `ToolDetail_container__WYLsJ`,
	"button": `ToolDetail_button__HJXBC`,
	"imagePreviewArea": `ToolDetail_imagePreviewArea__Sc2vw`,
	"imagePreview": `ToolDetail_imagePreview__v1yrs`,
	"info": `ToolDetail_info__Lk2lv`
};
export default ___CSS_LOADER_EXPORT___;
